import store from '@/store';
import eventHub from '@/scripts/eventHub';
import state from '../state';

class TouchManger {
  constructor(initiator) {
    this.initiator = initiator;
    this.holdTimeout = -1;

    this.touchMoveHandler = (event) => { this.move(event); };
    this.touchStartHandler = (event) => { this.down(event); };
    this.touchEndHandler = (event) => { this.up(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('touchmove', this.touchMoveHandler);
    this.initiator.DOMElement.addEventListener('touchstart', this.touchStartHandler);
    this.initiator.DOMElement.addEventListener('touchend', this.touchEndHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('touchmove', this.touchMoveHandler);
    this.initiator.DOMElement.removeEventListener('touchstart', this.touchStartHandler);
    this.initiator.DOMElement.removeEventListener('touchend', this.touchEndHandler);
  }

  move(event) {
    const t = event.changedTouches[0];
    const ex = t.clientX - this.initiator.boundings.left;
    const ey = t.clientY - this.initiator.boundings.top;
    const x = ex - this.initiator.center.x;
    const y = ey - this.initiator.center.y;
    this.initiator.point = { x, y };

    if (store.state.tutorial === 1 && (x > 150 || x < -150) && state.rayActive) {
      store.commit('SET_TUTORIAL', 2);
      eventHub.$emit('start-spawning');
      setTimeout(() => {
        store.commit('SET_TUTORIAL', 3);
      }, 3000);
    }
  }

  down() {
    this.initiator.hold();

    this.holdTimeout = setTimeout(() => {
      if (store.state.tutorial === 0) {
        store.commit('SET_TUTORIAL', 1);
      }
    }, 1000);
  }

  up() {
    this.initiator.release();

    clearTimeout(this.holdTimeout);
  }
}

export default TouchManger;
